module.exports = __webpack_public_path__ + "static/media/law4.d009b587.png";